export interface DealInvoice {
	id: number;
	guid: string;
	companyGuid: string | null;
	bankGuid: string | null;
	invoiceTypeDisplay: string;

	invoiceDate: Date;
	dueDate: Date;
	scheduleDueDate: Date;
	isCompanySubscriptionInvoice: boolean;
	invoiceAmount: number;
	amountPaid: number;
	balanceDue: number;
	invoiceFileName: string;
	lastSentToCompany: Date | null;
	invoiceType: InvoiceType;
	invoiceStage: InvoiceStage;
	paymentScheduleType: PaymentScheduleType;
	status: InvoiceStatus;
	scheduleStatus: InvoiceStatus;
	paymentOptionType: PaymentOptionType;
	isCreditMemo: boolean;
}

export type InvoiceType = keyof typeof InvoiceTypeMap;
export const InvoiceTypeMap = {
	CreditExplorer: 'Credit Explorer',
	ComplianceNavigator: 'Compliance Navigator',
	Addon: 'Addon',
	LenderSubscription: 'Lender Subscription',
	SbaPpp: 'SBA Paycheck Protection Program (PPP)',
	OtherFee: 'Other Fee',
};

export type InvoiceStage = keyof typeof InvoiceStageMap;
export const InvoiceStageMap = {
	Pending: 'Pending',
	Approved: 'Approved',
};

export type PaymentOptionType = keyof typeof PaymentOptionTypeMap;
export const PaymentOptionTypeMap = {
	Check: 'Check or ACH',
	CreditCard: 'Credit Card',
	Both: 'Both',
};

export type PaymentScheduleType = keyof typeof PaymentScheduleTypeMap;
export const PaymentScheduleTypeMap = {
	Now: 'Due Now',
	Net7: 'Net 7',
	Net15: 'Net 15',
	Net30: 'Net 30',
	Net60: 'Net 60',
	Custom: 'Custom',
};

export type InvoiceStatus = keyof typeof InvoiceStatusMap;
export const InvoiceStatusMap = {
	Paid: 'Paid',
	Partial: 'Partial Paid',
	PastDue: 'Past Due',
	Due: 'Due',
	Current: 'Current',
	Pending: 'Pending Approval',
	WriteOff: 'Write-Off',
};
